<template>
  <div class="container-fluid">
    <title-bar title="THIS FEATURE IS NOT UP TO DATE OR CURRENTLY BEING DEVELOPED"/>
    <div class="invisible row">
      <div class="col-md-3">
        <div class="card">
          <div class="card-header">
            ABOUT
          </div>
          <div class="card-body" style="font-weight: 300;">
            Welcome to The Medical Alley Association Board of Director’s dashboard.
            <br>
            The center column displays the make-up of the Association’s board on January 1st of the year.
          </div>
        </div>
        <div v-if="isLoaded">
          <collateral v-bind:collateral="boardOfDirectors.collateral"/>
        </div>
        <div class="" v-if="isLoaded">
          <div class="card mt-2">
            <div class="card-header">
              Organization Categories
            </div>
            <div class="card-body">
              <pie-chart :chart-data="organizationCategories" :options="chartOptions"></pie-chart>
            </div>
          </div>
          <!-- <div class="card flex-fill mt-2">
            <div class="card-header">
              Revenue Categories
            </div>
            <div class="card-body">
              <pie-chart :chart-data="revenueCategories" :options="chartOptions"></pie-chart>
            </div>
          </div> -->
          <div class="card flex-fill mt-2">
            <div class="card-header">
              Membership Categories
            </div>
            <div class="card-body">
              <pie-chart :chart-data="membershipCategories" :options="chartOptions"></pie-chart>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-7" v-if="isLoaded" >
        <div class="row ">
          <div class="col">
            <div class="card">
              <div class="card-body d-flex flex-column">
                <div class="d-flex p-1" :class="getRowClass(director)" v-for="director in getDirectors()" :key="director.individual_name + '_' + director.organization_name" style="border: solid 1px #eeeeee">
                  <div class="d-flex flex-fill flex-column">
                    <div class="d-flex flex-fill">
                      <div class="m-1 mr-3">
                        <img :src="director.logo_url" alt="" style="max-height: 50px">
                      </div>
                      <div class="d-flex align-items-center flex-fill">
                        <div class="d-flex flex-fill">
                          {{ director.individual_name }},&nbsp;
                          <span v-if="director.job_title !== null && director.job_title !== ''">{{ director.job_title }},&nbsp;</span>
                          {{ director.organization_name }}
                        </div>
                        <!-- <div class="ml-auto" v-if="director.seat_eligible_for_election"> REMOVE LINE ABOVE IF REINSTATING -->
                          <!-- <div class="d-flex badge badge-success" v-if="director.human_eligible_for_election">
                            Eligible for Election
                          </div>
                          <div class="d-flex badge badge-warning" v-if="!director.human_eligible_for_election">
                            Seat is eligible, director is not.
                          </div> -->
                        <!-- </div> -->
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="d-flex flex-column justify-content-center align-items-center flex-fill p-1 m-1" style="background: #eee">
                        <div>{{ director.term_start }}</div>
                        <div style="font-size: 12px; font-weight: 300; text-transform: capitalize">Year Joined</div>
                      </div>
                      <!-- <div class="d-flex flex-column justify-content-center align-items-center flex-fill p-1 m-1" style="background: #eee">
                        <div>{{ director.revenue_category }}</div>
                        <div style="font-size: 12px; font-weight: 300; text-transform: capitalize">Revenue Category</div>
                      </div> -->
                      <div class="d-flex flex-column justify-content-center align-items-center flex-fill p-1 m-1" style="background: #eee">
                        <div>{{ director.organization_category }}</div>
                        <div style="font-size: 12px; font-weight: 300; text-transform: capitalize">Organization Type</div>
                      </div>
                      <div class="d-flex flex-column justify-content-center align-items-center flex-fill p-1 m-1" style="background: #eee">
                        <div>{{ director.membership_category }}</div>
                        <div style="font-size: 12px; font-weight: 300; text-transform: capitalize">Membership Type</div>
                      </div>
                    </div>
                  </div>
                  <div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2" v-if="false">
          <div class="col">
            <div class="card">
              <div class="card-header">
                Foundational Members Not On Board.
              </div>
              <div class="card-body d-flex flex-wrap">
                <div class="d-flex align-items-center p-2 m-2 flex-fill" v-for="unseatedMember in unseatedMembers" :key="unseatedMember.account_id" style="border: solid 1px #eeeeee">
                  <div class="p-1"><img :src="unseatedMember.logo_url" alt="" style="max-height: 50px"></div>
                  <div>{{ unseatedMember.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="col-md-2" v-if="isLoaded">
        <!-- <div class="card">
          <div class="card-header">
            YEAR TO MODEL
          </div>
          <div class="card-body">
            <b-form-select v-model="selected" :options="options" size="sm" v-on:change="(e) => { newYearSelected(e) }" />
            <div class="mt-3">
              <b-form-checkbox switch v-model="filterElectableSeats" name="check-button">
                Show only electable seats.
              </b-form-checkbox>
            </div>
          </div>
        </div> -->
        <!-- <div class="card mt-2">
          <div class="card-header">
            CURRENT CYCLE NUMBER
          </div>
          <div class="card-body">
            <p class="cycle-number text-center" :style="'color:' + cycleColor">{{ cycleNumber }}</p>
          </div>
        </div> -->
        <div class="card">
          <div class="card-header">
            BOARD OFFICERS
          </div>
          <div class="card-body">
            <div class="board-officer-subsection text-center" v-for="officer in boardOfficers" :key="officer.individual_id">
              <span class='board-officer-title'>{{ officer.board_position }}</span><br>
              <span class='board-officer-name'>{{ officer.individual_name }}</span><hr/>
            </div>
          </div>
        </div>
        <div class="card mt-2">
          <div class="card-header">
            BYLAW COMMITTEE MEMBERS
          </div>
          <div class="card-body">
            <div class="board-officer-subsection text-center" v-for="(directors, key) in bylawCommittees" :key=key>
              <span class='board-officer-title'>{{ key }}</span><br>
              <span class="board-officer-name" v-for="director in directors" :key="director.individual_id">{{ director.individual_name }}<br></span>
              <hr/>
            </div>
          </div>
        </div>
        <div class="card mt-2">
          <div class="card-header">
            AD HOC COMMITTEE MEMBERS
          </div>
          <div class="card-body">
            <div class="board-officer-subsection text-center" v-for="(directors, key) in adhocCommittees" :key=key>
              <span class='board-officer-title'>{{ key }}</span><br>
              <span class="board-officer-name" v-for="director in directors" :key="director.individual_id">{{ director.individual_name }}<br></span>
              <hr/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PieChart from '../../utils/PieChart'
import DownloadableDocument from './DownloadableDocument'
import _ from 'lodash'
import Collateral from './Collateral'
import Helper from '../../utils'
import API from '../../api'
import TitleBar from '../homePage/TitleBar.vue'

export default {
  name: 'board-of-directors-index',
  components: {PieChart, DownloadableDocument, Collateral, TitleBar},
  data () {
    return {
      boardOfDirectors: null,
      filterElectableSeats: false,
      isLoaded: false,
      selected: new Date().getFullYear(),
      options: [
        { value: 2021, text: '2021' },
        { value: 2022, text: '2022' },
        { value: 2023, text: '2023' },
        { value: 2024, text: '2024' },
        { value: 2025, text: '2025' },
        { value: 2026, text: '2026' },
        { value: 2027, text: '2027' },
        { value: 2028, text: '2028' },
        { value: 2029, text: '2029' }
      ],
      palette: ['#BE1E2D', '#875F9A', '#59ABE3', '#8DB255', '#F5AB35', '#A1887F', '#95A5A6', '#D2D7D3'],
      selectedBoardDocument: null,
      chartOptions: {
        aspectRatio: 3,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          align: 'center'
        }
      },
      unseatedMembers: null
    }
  },
  computed: {
    cycleNumber: function () {
      return ((this.boardOfDirectors.year - 2008) % 3) + 1
    },
    cycleColor: function () {
      return this.palette[((this.boardOfDirectors.year - 2008) % 3)]
    },
    boardOfficers: function () {
      let boardOfficers = []
      _.forEach(this.boardOfDirectors.directors, function (director) {
        if (director.board_position === '') {
          return
        }
        boardOfficers.push(director)
      })
      boardOfficers.sort((a, b) => b.board_position_weight - a.board_position_weight)
      return boardOfficers
    },
    bylawCommittees: function () {
      let bylawCommitteesMap = {}
      _.forEach(this.boardOfDirectors.directors, function (director) {
        const bylawCommittees = director.bylaw_committee.split('|')
        _.forEach(bylawCommittees, function (bylawCommittee) {
          if (bylawCommittee === '') { return }
          bylawCommittee = bylawCommittee.trim()
          if (bylawCommittee in bylawCommitteesMap) {
            bylawCommitteesMap[bylawCommittee].push(director)
          } else {
            bylawCommitteesMap[bylawCommittee] = [director]
          }
          bylawCommitteesMap[bylawCommittee].sort((a, b) => b.board_position_weight - a.board_position_weight)
        })
      })
      return bylawCommitteesMap
    },
    adhocCommittees: function () {
      let adHocCommitteeMap = {}
      _.forEach(this.boardOfDirectors.directors, function (director) {
        const adHocCommittees = director.adhoc_committee.split('|')
        _.forEach(adHocCommittees, function (adHocCommittee) {
          if (adHocCommittee === '') { return }
          adHocCommittee = adHocCommittee.trim()
          if (adHocCommittee in adHocCommitteeMap) {
            adHocCommitteeMap[adHocCommittee].push(director)
          } else {
            adHocCommitteeMap[adHocCommittee] = [director]
          }
        })
      })
      return adHocCommitteeMap
    },
    organizationCategories: function () {
      let count = Helper.countValuesInListOfDictionariesForPieChart(this.boardOfDirectors.directors, 'organization_category')
      let chartData = {
        labels: [],
        datasets: [
          {
            label: 'Data One',
            data: [],
            backgroundColor: []
          }
        ]
      }
      for (let i = 0; i < count.length; i++) {
        chartData.labels.push(count[i].name)
        chartData.datasets[0].data.push(count[i].value)
        chartData.datasets[0].backgroundColor.push(Helper.colors[i % Helper.colors.length])
      }
      return chartData
    },
    membershipCategories: function () {
      let count = Helper.countValuesInListOfDictionariesForPieChart(this.boardOfDirectors.directors, 'membership_category')
      let chartData = {
        labels: [],
        datasets: [
          {
            label: 'Data One',
            data: [],
            backgroundColor: []
          }
        ]
      }
      for (let i = 0; i < count.length; i++) {
        chartData.labels.push(count[i].name)
        chartData.datasets[0].data.push(count[i].value)
        chartData.datasets[0].backgroundColor.push(Helper.colors[i % Helper.colors.length])
      }
      return chartData
    },
    revenueCategories: function () {
      let count = Helper.countValuesInListOfDictionariesForPieChart(this.boardOfDirectors.directors, 'revenue_category')
      let chartData = {
        labels: [],
        datasets: [
          {
            label: 'Data One',
            data: [],
            backgroundColor: []
          }
        ]
      }
      for (let i = 0; i < count.length; i++) {
        chartData.labels.push(count[i].name)
        chartData.datasets[0].data.push(count[i].value)
        chartData.datasets[0].backgroundColor.push(Helper.colors[i % Helper.colors.length])
      }
      return chartData
    }
  },
  methods: {
    openDocuments (e) {
      if (e === this.selectedBoardDocument) {
        this.selectedBoardDocument = null
      } else {
        this.selectedBoardDocument = e
      }
    },
    getDirectors () {
      if (this.filterElectableSeats) {
        return this.boardOfDirectors.directors.filter((x) => x.seat_eligible_for_election)
      } else {
        return this.boardOfDirectors.directors
      }
    },
    getS3File (filename) {
      API.getS3FileURL(filename).then(
        response => {
          const url = response.data.url
        }
      )
    },
    newYearSelected (event) {
      this.setDirectorData(event)
    },
    getRowClass (director) {
      return 'eligible'
      // REMOVE ABOVE LINE IF REINSTATING!!! if (director.years_served === 9) {
      //   return 'must-leave'
      // } else if (director.years_served > 9) {
      //   return 'ineligible'
      // } else {
      //   return 'eligible'
      // }
    },
    setDirectorData (year) {
      this.isLoaded = false
      this.boardOfDirectors = null
      API.getBoardOfDirectors(year)
        .then(response => {
          this.boardOfDirectors = response.data
          this.boardOfDirectors.directors.sort((a, b) => b.board_position_weight - a.board_position_weight)
          this.unseatedMembers = response.data.unseated_organizations
          this.selected = this.boardOfDirectors.year
          this.isLoaded = true
        })
    },
  },
  mounted () {
    this.setDirectorData(new Date().getFullYear())

  }
}
</script>

<style scoped>
  .cycle-number{
    font-size: 3em;
  }
  .board-officer-name{
    font-size: 20px;
  }
  .board-officer-title{
    font-weight: 300;
  }
  th, .light-row{
    font-weight: 300;
  }
  .ineligible{
    background: #ddd;
    color: #bbb;
  }
  .electable{
    background: #ff9900;
    color: #fff;
  }
  .must-leave{
    background: #BE1E2D;
    color: #bbb;

  }
  .btn-link:hover{
    text-decoration: none;
  }
  .btn-link:active{
    text-decoration: none;
  }
  .btn-link{
    text-decoration: none;
    color: #BE1E2D;
  }
</style>



// WEBPACK FOOTER //
// src/components/boardOfDirectors/Index.vue